// Which environments may write to CBS's FTP. There is only the one live FTP, so outside prod
// writes stay off until switched on for that environment on the Internal Features page. Prod is
// on unless switched off there.

import type {ApiEnvironment} from './constants/environments';

export const TOGGLEABLE_FTP_WRITE_ENVIRONMENTS = [
  'local',
  'dev',
  'staging',
  'vbatest',
  'prod',
] as const satisfies readonly ApiEnvironment[];

export type ToggleableFtpWriteEnvironment = (typeof TOGGLEABLE_FTP_WRITE_ENVIRONMENTS)[number];

// Keyed by environment, so a prod database restored into another environment stays off there.
export type FtpWritesConfig = Partial<Record<ToggleableFtpWriteEnvironment, {enabled: boolean}>>;

export function ftpWritesEnabled(
  environment: ApiEnvironment,
  config: FtpWritesConfig | null | undefined,
): boolean {
  const enabled = config?.[environment]?.enabled;
  return environment === 'prod' ? enabled !== false : enabled === true;
}
